import {Background} from "../background/Background";
import { Base } from '../templates/Base';

const Home = () => (<Background><Base/></Background>);

export default Home;
